import { Box, Button, Paper } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import React from 'react'
import styled from 'styled-components'

import {
  COMPANY_STATUS,
  COMPANY_STATUS_TRANSITION_TYPE
} from '../../constants/enums/company.enum.constant'

const StyledPaperContainer = styled(Paper)`
  height: 100%;
  margin-bottom: 10px;
  padding: 20px;
`

const StyledButtonContainer = styled.div`
  margin: 0px 5px 0px 5px;
`

const StyledButton = (props: any) => (
  <StyledButtonContainer>
    <Button {...props} />
  </StyledButtonContainer>
)

const CompanyFormHandlerBtnBar = ({
  saveHandler,
  createHandler,
  statusChangeHandler,
  disableForm,
  newForm,
  companyStatus
}: {
  saveHandler: (...args: any) => any
  createHandler: (...args: any) => any
  statusChangeHandler: (...args: any) => any
  disableForm: boolean
  newForm: boolean
  companyStatus: number
}) => {
  return (
    <StyledPaperContainer>
      <Box display="flex" justifyContent="flex-end">
        {newForm ? (
          <StyledButton
            variant="contained"
            color="primary"
            onClick={createHandler}
          >
            Create
          </StyledButton>
        ) : (
          <>
            <StyledButton
              variant="outlined"
              color="default"
              onClick={saveHandler}
              disabled={disableForm}
            >
              Save
            </StyledButton>
            {!disableForm &&
              (companyStatus === COMPANY_STATUS.new ? (
                <StyledButton
                  variant="contained"
                  color="primary"
                  onClick={statusChangeHandler(
                    COMPANY_STATUS_TRANSITION_TYPE.publish
                  )}
                >
                  Publish
                </StyledButton>
              ) : (
                <StyledButton
                  variant="outlined"
                  color="primary"
                  onClick={statusChangeHandler(
                    COMPANY_STATUS_TRANSITION_TYPE.unpublish
                  )}
                >
                  Unpublish
                </StyledButton>
              ))}
            {!disableForm ? (
              <StyledButton
                variant="contained"
                color="secondary"
                onClick={statusChangeHandler(
                  COMPANY_STATUS_TRANSITION_TYPE.archive
                )}
              >
                <DeleteIcon />
                Archive
              </StyledButton>
            ) : (
              <StyledButton
                variant="contained"
                color="primary"
                onClick={statusChangeHandler(
                  COMPANY_STATUS_TRANSITION_TYPE.reopen
                )}
              >
                Reopen
              </StyledButton>
            )}
          </>
        )}
      </Box>
    </StyledPaperContainer>
  )
}
export default CompanyFormHandlerBtnBar
